import React from 'react';
import { Route } from 'react-router-dom';
import { RouteWrapper } from './RouteWrapper';
import {
  LazyMarketplace,
  LazyMarketplaceProperties,
  LazyPropertyDetail,
  LazyFinancing,
} from '@/components/LazyComponents';

/**
 * Rotas para subdomínios de tenant (ex: claudiogarcia.imobpanda.site)
 * 
 * IMPORTANTE: Estas rotas são usadas APENAS em subdomínios de tenant.
 * Sites personalizados NÃO devem ser acessíveis via path no domínio principal
 * (ex: imobpanda.com/claudiogarcia) para evitar duplicação de conteúdo e
 * problemas de SEO.
 */
export const TenantRoutes = () => {
  return (
    <>
      {/* Home do tenant - raiz do subdomínio */}
      <Route
        path="/"
        element={
          <RouteWrapper withTenant withMarketing withTenantMarketplace>
            <LazyMarketplace />
          </RouteWrapper>
        }
      />

      {/* Lista de propriedades do tenant */}
      <Route
        path="/properties"
        element={
          <RouteWrapper withTenant withMarketing withTenantMarketplace>
            <LazyMarketplaceProperties />
          </RouteWrapper>
        }
      />

      {/* Detalhe do imóvel - SEO friendly */}
      <Route
        path="/imovel/:id"
        element={
          <RouteWrapper withTenant withMarketing withTenantMarketplace>
            <LazyPropertyDetail />
          </RouteWrapper>
        }
      />

      {/* Legacy route para compatibilidade */}
      <Route
        path="/properties/:id"
        element={
          <RouteWrapper withTenant withMarketing withTenantMarketplace>
            <LazyPropertyDetail />
          </RouteWrapper>
        }
      />

      {/* Rota de Financiamentos */}
      <Route
        path="/financiamento"
        element={
          <RouteWrapper withTenant withMarketing withTenantMarketplace>
            <LazyFinancing />
          </RouteWrapper>
        }
      />

    </>
  );
};

